import { CircularProgress, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import debounce from 'lodash.debounce';
import React, { useState, useEffect, useCallback } from 'react';
import { DEBOUNCE_DELAY_MS } from '../../../constants';
import { getSubscriptions } from '../../../services/apiService';
import { getFullName } from '../../../utils';

const UserSelection = ({ value, setValue }) => {
  const [searchOptions, setSearchOptions] = useState(null);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const changeHandler = async (value) => {
    const query = await getSubscriptions({ query: value });
    setSearchOptions(query);
    setLoading(false);
  };

  const debouncedChangeHandler = useCallback(
    debounce(changeHandler, DEBOUNCE_DELAY_MS),
    []
  );

  useEffect(() => {
    if (inputValue !== '') {
      setLoading(true);
      debouncedChangeHandler(inputValue);
    } else {
      setSearchOptions(null);
      setLoading(false);
    }
  }, [inputValue]);
  return (
    <Autocomplete
      multiple
      filterSelectedOptions
      options={searchOptions || []}
      getOptionLabel={(option) => {
        if (typeof option === 'string') {
          return option;
        }
        return getFullName(option.User);
      }}
      value={value}
      onChange={(e, newValue) => {
        if (!newValue) setValue(null);
        setValue(newValue);
      }}
      inputValue={inputValue}
      onInputChange={(e, newValue) => setInputValue(newValue)}
      filterOptions={(options) => options}
      getOptionSelected={(option, value) => option.userId === value.userId}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label='Users'
          variant='outlined'
          placeholder='Search for users'
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading && <CircularProgress color='inherit' size={20} />}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default UserSelection;
